<template>
  <div class="upgrade-required">
    <div class="content">
      <h2 class="title">You need to upgrade your Routine app.</h2>
      <p class="message">
        Either apply the update by restarting or download the latest Routine
        version on
        <BaseLink @click="openDownloadPage"> routine.co/download </BaseLink>
      </p>
      <p class="versions">
        <span
          >Current version: <strong>{{ currentVersion }}</strong></span
        >
        <span v-if="requiredVersion"
          >Required version: <strong>{{ requiredVersion }}</strong></span
        >
      </p>
    </div>
    <Notification v-if="notification" :notification="notification" />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

import controller from "@ctrl/controller";
import type { Notification as NotificationSchema } from "@ctrl/controller-rpc";

import BaseLink from "@/components/base/BaseLink.vue";
import Notification from "@/components/notification/Notification.vue";
import { openExternalUrl } from "@/utils/open-external-url";

const { version: currentVersion } = controller;

export default defineComponent({
  name: "UpgradeRequired",
  components: {
    Notification,
    BaseLink,
  },
  props: {
    notification: {
      type: Object as PropType<NotificationSchema | null>,
      default: null,
    },
    requiredVersion: {
      type: String,
      default: null,
    },
  },
  setup() {
    const openDownloadPage = () => {
      openExternalUrl("https://routine.co/download", null);
    };
    return { openDownloadPage, currentVersion };
  },
});
</script>

<style scoped lang="scss">
.upgrade-required {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .title {
    margin: 24px 0 12px 0;
    @extend %font-h3;
  }

  .message {
    margin: 0;
    max-width: 400px;
    @extend %font-body-regular;
    line-height: 1.5;
    @include themed() {
      color: t($grey-60);
    }
  }

  .versions {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    margin: 16px 0 0 0;
    @extend %font-small-regular;
    @include themed() {
      color: t($grey-60);
    }
  }
}
</style>
